import { useQuery } from '@tanstack/react-query'

import requests from 'service/api'

import { Label } from '@radix-ui/react-label'
import { CaretSortIcon } from '@radix-ui/react-icons'
import { Select } from 'antd'
import { useFormikContext } from 'formik'
import { useEffect, useState, useMemo } from 'react'
import { BASE_URL,BASE_URL2 } from 'config/axios'

export function SelectSymbolPriceLabel12({ washType,brrand,index }) {
  const { setFieldValue, values } = useFormikContext()
  const [selected, setSelected] = useState(null)
  const [imgValue, setImgValue] = useState(null)

  const { data, isFetched } = useQuery({
    queryKey: ['/list', 'symbol', washType],
    queryFn: async () => {
      if(brrand === "ZaraHome"){
        const { data } = await requests.symbol.listHome(washType)
        return data
      }else{
        const { data } = await requests.symbol.list(washType)
        return data
      }
    },
    enabled: !!washType,
    placeholderData: []
  })

  const options = useMemo(() => data?.group?.map(({ value, name }) => ({
    value,
    label: name
  })) || [], [data])

  useEffect(() => {
    if (
      values.zaraHomeLabel12?.[0]?.symbol?.[washType] && 
      isFetched &&
      options.length > 0
    ) {
      const select = options.find(({ value }) => value === values.zaraHomeLabel12[0].symbol[washType])
      setSelected(select)
      setImgValue(values.zaraHomeLabel12[0].symbol[washType])
    } else {
      // Reset selection if no valid data
      setSelected(null)
      setImgValue(null)
    }
    // eslint-disable-next-line
  }, [values.zaraHomeLabel12?.[0]?.symbol?.[washType], isFetched, washType, options])

  return (
    <div className="grid grid-cols-[80px_1fr_50px] items-center">
      <Label className="text-sm text-simsek font-medium uppercase">{washType}</Label>
      <Select
        showSearch
        suffixIcon={<CaretSortIcon />}
        className="h-10 w-full"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        options={options}
        onSelect={(value) => {
          setFieldValue(`zaraHomeLabel12[0].symbol.${washType}`, value)
          setImgValue(value)
        }}
        value={selected}
        onChange={(e) => setSelected(e)}
      />
      <div className="flex justify-center">
        {imgValue && (
          <img
            src={`${BASE_URL2}/imageshome/symbols/${washType}/${imgValue}.svg`}
            alt="symbol logo"
            className="h-8"
          />
        )}
      </div>
    </div>
  )
}
